import { LayoutKey } from '@rapoo/device-sdk'
import { BASIC_KEYS_LABEL_MAP, MEDIA_KEYS_LABEL_MAP, MOUSE_KEY_ITEMS_MAP } from '../utils/constants'
import { getLocalizedField } from '../utils/keyMapSetting'
import { KeySetting } from '../types'
import { useLocaleStore } from '@/stores'
import { Ref } from 'vue'

export function useKeyLabel(keySettings: Ref<KeySetting[]>) {
  const { t } = useLocaleStore()

  const isKeyModified = (mouseKey: LayoutKey) => {
    return keySettings.value.some((s) => s.keywords === mouseKey.keywords && s.isModified)
  }

  function getKeyLabel(mouseKey: LayoutKey, needAppend?: true): string
  function getKeyLabel(
    mouseKey: LayoutKey,
    needAppend: false,
  ): { originalLabel: string; targetLabel?: string }
  function getKeyLabel(
    mouseKey: LayoutKey,
    needAppend = true,
  ): string | { originalLabel: string; targetLabel?: string } {
    const originalLabel =
      t(MOUSE_KEY_ITEMS_MAP.get(mouseKey.keywords)?.name || '') || mouseKey.keywords
    const setting = keySettings.value.find((s) => s.keywords === mouseKey.keywords && s.isModified)
    if (!setting) return needAppend ? originalLabel : { originalLabel }

    let targetLabel = ''

    // 优先从 BASIC_KEYS_LABEL_MAP 通过 target 的 keywords 获取可读 label
    if (setting.target && typeof setting.target === 'object' && 'keywords' in setting.target) {
      const basicLabelKey = BASIC_KEYS_LABEL_MAP.get((setting.target as any).keywords)
      if (basicLabelKey) {
        targetLabel = t(basicLabelKey)
      }
    }

    // 回退到 MEDIA_KEYS_LABEL_MAP，通过 i18n key 翻译为可读 label
    if (
      !targetLabel &&
      setting.target &&
      typeof setting.target === 'object' &&
      'keywords' in setting.target
    ) {
      const mediaLabelKey = MEDIA_KEYS_LABEL_MAP.get((setting.target as any).keywords)
      if (mediaLabelKey) {
        targetLabel = t(mediaLabelKey)
      }
    }

    // 回退到 target 的 alias/name
    if (
      !targetLabel &&
      setting.target &&
      typeof setting.target === 'object' &&
      'name' in setting.target
    ) {
      targetLabel = getLocalizedField(
        (setting.target as any).alias || (setting.target as any).name || '',
      )
    }
    if (!targetLabel && setting.raw?.macroName) {
      targetLabel = setting.raw.macroName
    }
    if (!targetLabel && setting.raw?.combinedLabel) {
      targetLabel = setting.raw.combinedLabel
    }
    if (!targetLabel && setting.raw?.originalLabel) {
      targetLabel = setting.raw.originalLabel
    }
    if (!targetLabel) return needAppend ? originalLabel : { originalLabel }

    return needAppend ? `${originalLabel}：${targetLabel}` : { originalLabel, targetLabel }
  }
  return {
    isKeyModified,
    getKeyLabel,
  }
}
